// extracted by mini-css-extract-plugin
export default {"modalForm":"Form--modalForm--f5a68f"};